import React, { Component } from "react";
import Label from "./Label";
import Checkbox from "./Checkbox";

export class CheckboxGroup extends Component {
  render() {
    var checkboxes =[];
    for (var c in this.props.checkboxes) {
      checkboxes.push(<Checkbox 
        key={c}
        name={c}
        checked={this.props.checkboxes[c].is_checked}
        label={this.props.checkboxes[c].label}
        onChange={this.props.onChange} />);
    };

    return (
      <div>
      <Label name={this.props.label_name} required={this.props.required} />
        {checkboxes}
      </div>
    );
  }
}